import { NgModule } from '@angular/core';
import { AppMaskDirective } from './app-mask.directive';
import { MaskPipe } from './mask.pipe';

@NgModule({
  declarations: [AppMaskDirective, MaskPipe],
  exports: [AppMaskDirective, MaskPipe],
})
export class AppMaskModule {}
